import { api } from "./config.js";

const getBranchEndpoint = (branchId) => {
  const baseURL = api.defaults.baseURL || "";
  const prefix = baseURL.replace(/\/$/, "").endsWith("/api") ? "" : "/api";

  return `${prefix}/app/showBranch/${branchId}`;
};

const normalizeBranch = (payload) => {
  if (payload?.branch) {
    return payload.branch;
  }

  if (payload?.data?.branch) {
    return payload.data.branch;
  }

  if (payload?.data) {
    return payload.data;
  }

  return null;
};

export const getBranch = async (branchId) => {
  const response = await api.get(getBranchEndpoint(branchId));
  return normalizeBranch(response.data);
};
